/* SM WORKS: Kurze Clips laufen stumm in Schleife, solange sie im Bild sind (Thomas 03.11.2026). Bei „weniger Bewegung“ bleibt das Standbild. */
(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var io = new IntersectionObserver(function (eintraege) {
    eintraege.forEach(function (e) {
      var v = e.target;
      if (e.isIntersecting) { v.preload = 'auto'; var p = v.play(); if (p && p.catch) p.catch(function () {}); }
      else v.pause();
    });
  }, { threshold: 0.25 });
  document.querySelectorAll('video[data-smw-clip]').forEach(function (v) { v.muted = true; io.observe(v); });
})();
